import { Router } from 'framework7/types';
import { AIChatPage } from '@/components/pages/AIChat/AIChatPage';
import { paths } from '@/config/paths';

export const aiChatRoutes: Router.RouteParameters[] = [
  {
    path: paths.aiChat,
    // ログインの車両選択と同じく、下からせり上がるポップアップとして開く
    popup: {
      component: AIChatPage,
    },
    name: 'マイくるAI',
    options: {
      animate: true,
    },
  },
];
